// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questions_main__KRcA- {
  padding: 16px 16px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100dvh;
}

.questions_title__5Y3R0 {
  font-size: 24px;
  font-weight: 700;
  line-height: 28.64px;
  letter-spacing: -0.0143em;
  text-align: center;
  color: white;
}

.questions_question__pLgvY {
  min-height: 200px;
  padding: 8px;
  background: white;
  border-radius: 10px;
  margin-top: 20px;
  width: 100%;
  color: black;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -0.0143em;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
}

.questions_answersWrapper__ou4Qd {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.questions_answer__6gGHU {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 19.09px;
  letter-spacing: -0.0143em;
  text-align: center;
  color: white;
  cursor: pointer;
}

.questions_spacer__WfUJh {
  flex: 1 1;
}

.questions_input__VC6F\\+ {
  height: 48px;
  width: 100%;
  border: 1px solid white;
  background: transparent;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: -0.0143em;
  color: white;
  padding-left: 13px;
  padding-right: 13px;
  box-sizing: border-box;
}

.questions_progressBarContainer__g-q5C {
  width: 100%;
  padding-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/Questions/questions.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB","sourcesContent":[".main {\n  padding: 16px 16px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100dvh;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 28.64px;\n  letter-spacing: -0.0143em;\n  text-align: center;\n  color: white;\n}\n\n.question {\n  min-height: 200px;\n  padding: 8px;\n  background: white;\n  border-radius: 10px;\n  margin-top: 20px;\n  width: 100%;\n  color: black;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: -0.0143em;\n  text-align: center;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.answersWrapper {\n  margin-top: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.answer {\n  width: 100%;\n  height: 44px;\n  border-radius: 10px;\n  border: 1px solid white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 19.09px;\n  letter-spacing: -0.0143em;\n  text-align: center;\n  color: white;\n  cursor: pointer;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.input {\n  height: 48px;\n  width: 100%;\n  border: 1px solid white;\n  background: transparent;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: -0.0143em;\n  color: white;\n  padding-left: 13px;\n  padding-right: 13px;\n  box-sizing: border-box;\n}\n\n.progressBarContainer {\n  width: 100%;\n  padding-bottom: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `questions_main__KRcA-`,
	"title": `questions_title__5Y3R0`,
	"question": `questions_question__pLgvY`,
	"answersWrapper": `questions_answersWrapper__ou4Qd`,
	"answer": `questions_answer__6gGHU`,
	"spacer": `questions_spacer__WfUJh`,
	"input": `questions_input__VC6F+`,
	"progressBarContainer": `questions_progressBarContainer__g-q5C`
};
export default ___CSS_LOADER_EXPORT___;
